import { useEffect } from 'react';
import type { VatReturnsState } from './useVatReturns.ts';

export function useOpenLinkedVatReturnVersion(
    vatReturns: VatReturnsState,
    isActive: boolean,
    linkedSnapshotId: string | null,
    clearLink: () => void,
): void {
    const { periods, isFetchingSnapshots, hasSnapshotsLoadError, selectVersion } = vatReturns;

    useEffect(() => {
        if (!isActive || linkedSnapshotId === null) {
            return;
        }
        const linkedPeriod = periods.find((period) => period.versions.some((version) => version.id === linkedSnapshotId));
        if (linkedPeriod) {
            selectVersion(linkedPeriod.key, linkedSnapshotId);
            clearLink();
        } else if (!isFetchingSnapshots && (hasSnapshotsLoadError || periods.length > 0)) {
            clearLink();
        }
    }, [isActive, linkedSnapshotId, isFetchingSnapshots, hasSnapshotsLoadError, periods, selectVersion, clearLink]);
}
